import React from "react";

import UserContext from "contexts/UserContext";

const useUserContext = () => React.useContext(UserContext);

export default useUserContext;
